<email-layout>
  <ng-container header>
    <email-message-header [header]="data.header" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data.body_html" />
    <br />
    <br />
    <email-text [contents]="data.code_html" />
    <br />
    <email-text [contents]="data.error_html" />
    <email-margin [height]="18" />
  </ng-container>
</email-layout>
